<template>
  <v-container class="timeslot-selector fill-height mt-1">
    <v-layout fill-height column>
      <div
        class="d-flex flex-column justify-center mb-6"
        v-if="category.metaData && category.metaData.category_info"
      >
        <!-- <div
          class="text-h4 font-weight-bold primary--text text--lighten-1 text-center ma-4 mb-0"
        >
          {{ category.metaData.category_info.TITLE }}
        </div> -->
        <h2
          class="text-h4 font-weight-bold primary--text text--lighten-1 text-center ma-4 mb-4"
          v-if="category.metaData.category_info.TITLE"
        >
          {{ category.metaData.category_info.TITLE }}
        </h2>

        <div
          v-if="category.metaData.category_info.DESCRIPTION"
          v-html="category.metaData.category_info.DESCRIPTION"
        ></div>
        <div class="selector-subtitle">
          <p class="mb-2 text-center">
            <strong v-if="cart.shippingAddress.addressType == 'home'">{{
              $t("timeslots.addressSelectedDelivery")
            }}</strong>
            <strong v-else>{{ $t("timeslots.addressSelectedDrive") }}</strong>
            {{
              cart.shippingAddress.addressName +
                " - " +
                $t(
                  "navbar.address." +
                    cart.shippingAddress.addressTypeId +
                    ".list",
                  cart.shippingAddress
                )
            }}
          </p>
        </div>

        <!-- <v-icon small color="primary" right @click="changeAddress">
            $edit
          </v-icon> -->
      </div>

      <!-- <v-divider></v-divider> -->
      <v-tabs
        hide-slider
        icons-and-text
        v-model="tab"
        :height="$vuetify.breakpoint.smAndDown ? 80 : 110"
        center-active
        show-arrows
        v-if="timeslots.length > 0"
      >
        <v-tabs-slider></v-tabs-slider>
        <v-tab
          v-for="timeslotDay in timeslots"
          :key="timeslotDay.dateIso"
          @click="selectTimeslotDay(timeslotDay)"
        >
          <div
            class="time-div d-flex flex-column align-center justify-space-around"
          >
            <template v-if="checkIfIsToday(timeslotDay.dateIso)">
              <span class="day-number font-weight-bold">
                {{ $t("timeslots.today") }}
              </span>
            </template>
            <template v-else>
              <span class="day-string">
                {{ $dayjs(timeslotDay.dateIso).format("dddd") }}
              </span>
              <span class="day-number font-weight-bold">
                {{ $dayjs(timeslotDay.dateIso).format("D") }}
              </span>
              <span class="month">{{
                $dayjs(timeslotDay.dateIso).format("MMMM")
              }}</span>
            </template>
          </div>
        </v-tab>
      </v-tabs>
      <v-tabs v-else-if="loading === false">
        Non ci sono fasce disponibili per questa zona
      </v-tabs>
      <!-- <v-divider></v-divider> -->
      <v-tabs-items v-model="tab" class="mb-8 mt-5">
        <v-tab-item
          class="timeslot-container"
          v-for="timeslotDay in timeslots"
          :key="timeslotDay.dateIso"
        >
          <v-row no-gutters>
            <v-col
              cols="6"
              md="3"
              v-for="timeslot in timeslotDay.timeslots"
              :key="timeslot.timeslotId"
            >
              <v-card class="timeslot-card" flat :disabled="disabled">
                <div
                  v-on:click="selectTimeslot(timeslot)"
                  class="timeslot-button d-flex justify-center"
                  v-bind:class="[
                    timeslot.status,
                    timeslot.selected ? 'selected' : ''
                  ]"
                >
                  <!-- <span v-if="!isDelivery" class="timeslot-time"
                    >{{ timeslot.beginTime }} - {{ timeslot.endTime }}</span
                  > -->
                  <span class="timeslot-time">
                    {{ timeslot.name }}
                  </span>
                  <!-- <span
                    v-if="timeslot.status === 'intermediate'"
                    class="text-status"
                    >{{ $t("timeslots.slotAttribute.slotIntemediate") }}</span
                  > -->
                  <!-- <span v-if="timeslot.status === 'full'" class="text-status">{{
                    $t("timeslots.slotAttribute.slotFull")
                  }}</span> -->
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-tab-item>
      </v-tabs-items>
      <v-divider></v-divider>
      <!-- <v-spacer></v-spacer> -->
      <v-row class="legend align-center" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="4" sm="2" class="py-0">
          <div class="timeslot-legend empty">
            <span>{{ $t("timeslots.slotAttribute.empty") }}</span>
          </div>
        </v-col>
        <!-- <v-col cols="3" sm="2" class="py-0">
          <div class="timeslot-legend intermediate">
            <span>{{ $t("timeslots.slotAttribute.intermediate") }}</span>
          </div>
        </v-col> -->
        <v-col cols="4" sm="2" class="py-0">
          <div class="timeslot-legend full">
            <span>{{ $t("timeslots.slotAttribute.full") }}</span>
          </div>
        </v-col>
        <v-col cols="4" sm="2" class="py-">
          <div class="timeslot-legend selected">
            <span>{{ $t("timeslots.slotAttribute.selected") }}</span>
          </div>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
    </v-layout>
  </v-container>
</template>
<script>
// @ is an alias to /src
import DeliveryService from "~/service/deliveryService";
import CategoryService from "~/service/categoryService";
import cartInfo from "~/mixins/cartInfo";
import { mapState } from "vuex";
var vm;
export default {
  name: "TimeslotSelector",
  mixins: [cartInfo],
  data() {
    return {
      timeslots: [],
      tab: 0,
      selectedTimeslotDay: {},
      disabled: false,
      category: {},
      loading: null
    };
  },
  computed: {
    ...mapState({
      cart: ({ cart }) => cart.cart
    }),
    isDelivery() {
      return this.cart.shippingAddress.addressType == "home";
    }
  },
  methods: {
    openAddressSelector() {
      this.$emit("submit", "setAddress");
    },
    checkIfIsToday(date) {
      return this.$dayjs().isSame(date, "day");
    },
    selectTimeslotDay(day) {
      this.selectedTimeslotDay = day;
    },
    async selectTimeslot(timeslot) {
      if (timeslot.active < 1) {
        return;
      }
      this.disabled = true;
      let data = await this.$store.dispatch("cart/setTimeslot", {
        dateIso: this.selectedTimeslotDay.dateIso,
        timeslotId: timeslot.timeslotId
      });
      if (data) {
        this.$emit("submit", true);
      }
    },
    async fetchTimeslots() {
      vm.loading = true;
      let timeslots = await DeliveryService.getTimeslotList(false);

      for (let i = 0; i < timeslots.length; i++) {
        if (timeslots[i].timeslots.length > 0) {
          vm.timeslots.push(timeslots[i]);
        }
      }
      // if (vm.timeslots.length > 1 && vm.timeslots[0].timeslots.length == 0) {
      //   vm.timeslots.push();
      // }

      for (let i = 0; i < vm.timeslots.length; i++) {
        if (vm.timeslots[i].dateIso == vm.cart.timeslot.date) {
          vm.tab = i;
          this.selectedTimeslotDay = vm.timeslots[i];
          break;
        }
      }
      vm.loading = false;
      // if (!vm.selectedTimeslotDay.dateIso) {
      //   vm.selectTimeslotDay(vm.timeslots[0]);
      // }
    },
    async fetchCategory() {
      try {
        this.category = await CategoryService.getCategoryBySlug(
          "timeslot-selector-b2b"
        );
      } catch (e) {
        console.log(e);
      }
    }
  },

  created() {
    // fetch the data when the view is created and the data is
    // already being observed
    vm = this;
    this.disabled = false;
    this.fetchTimeslots();
    this.fetchCategory();
    // this.getDayTabName();
  }
};
</script>
